import React, { useEffect, useState } from "react";
import { _single_business_menu } from "../../common/axios_services";
import { Button, notification, Spin } from "antd";
import { useParams } from "react-router-dom";
import deleteIcon from "../../assets/images/restaurant/delete.svg";
import { useDispatch } from "react-redux";
import {
  changeQuantity,
  setRestaurant,
} from "../../slices/restaurantCartSlice";
import { LoadingOutlined } from "@ant-design/icons";
import NumberFormat from "react-number-format";
import { roundDisplayPrice } from "../../utils/priceHelpers";

const CartItem = (props) => {
  const { id: paramRestaurantId } = useParams();
  const businessType = props.businessType;
  const { data, packIndex, onDelete } = props;
  const { productId, quantity, extras = [] } = props.data || {};
  const [detail, setDetail] = useState(data?.detail || data?.item || null);
  const [restaurantProducts, setRestaurantProducts] = useState([]);
  const [extrasState, setExtrasState] = useState(
    [...extras].filter(e => e.id !== "container_cost" && e.item?.name !== "Container Cost")
  );
  const dispatch = useDispatch();
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  const restaurantId = data?.businessId || data?.restaurantId || paramRestaurantId;

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: "",
      description: message,
    });
  };

  const fetchMenu = async (id) => {
    if (!id) return;
    try {
      const response = await _single_business_menu({
        page: 1,
        per_page: 50,
        businessId: id,
        type: businessType,
      });
      setRestaurantProducts(response?.data?.data || []);
    } catch (err) {
    }
  };

  useEffect(() => {
    if (restaurantId) {
      fetchMenu(restaurantId);
    }
  }, [restaurantId, businessType]);

  useEffect(() => {
    if (data?.detail || data?.item) {
      setDetail(data.detail || data.item);
    }
  }, [data]);

  useEffect(() => {
    if (restaurantProducts.length > 0 && productId) {
      const foundProduct = restaurantProducts.find(
        (product) => product.id === productId
      );
      if (foundProduct) {
        setDetail(foundProduct);
      }
    }
  }, [restaurantProducts, productId]);

  const activeDetail = detail || data?.detail || data?.item || data;

  useEffect(() => {
    if (extras.some(e => e.id === "container_cost" || e.item?.name === "Container Cost")) {
      const cleaned = extras.filter(e => e.id !== "container_cost" && e.item?.name !== "Container Cost");
      setExtrasState(cleaned);
      dispatch(
        changeQuantity({
          productId,
          quantity,
          extras: cleaned,
        })
      );
    }
  }, [extras, productId, quantity, dispatch]);

  const handleExtraQuantityChange = (extraId, change) => {
    setExtrasState((prevExtras) => {
      const updatedExtras = prevExtras.map((extra) =>
        extra.id === extraId
          ? { ...extra, quantity: Math.max(1, extra.quantity + change) }
          : extra
      );

      const finalExtras = updatedExtras.filter((extra) => extra.quantity > 0);

      dispatch(
        changeQuantity({
          productId,
          quantity,
          extras: finalExtras,
        })
      );

      return finalExtras;
    });
  };

  const handleRemoveExtra = (extraId) => {
    setExtrasState((prevExtras) => {
      const updatedExtras = prevExtras.filter((extra) => extra.id !== extraId);

      dispatch(
        changeQuantity({
          productId,
          quantity,
          extras: updatedExtras,
        })
      );

      return updatedExtras;
    });
  };

  const handleMinusQuantity = () => {
    if (quantity <= 1) return;
    const newQty = quantity - 1;
    dispatch(
      changeQuantity({
        productId: productId,
        quantity: newQty,
        extras: extrasState,
      })
    );
  };

  const handleAddQuantity = () => {
    const newQty = quantity + 1;
    dispatch(
      changeQuantity({
        productId: productId,
        quantity: newQty,
        extras: extrasState,
      })
    );
  };

  const formatString = (str) => {
    return str
      .replace(/_/g, " ")
      .split(" ")
      .map((word) => {
        if (!isNaN(word)) return word;
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(" ");
  };

  const discount = activeDetail?.discount ? parseFloat(activeDetail.discount) : 0;
  const originalPrice = parseFloat(activeDetail?.public_price || activeDetail?.price || 0);
  const discountedPrice =
    discount > 0
      ? (originalPrice * (1 - discount / 100)).toFixed(2)
      : originalPrice.toFixed(2);

  const renderPackType = () => {
    if (!activeDetail?.packType) return null;
    return (
      <p className="text-lg text-gray-500">
        {formatString(activeDetail.packType)}
      </p>
    );
  };

  return (
    <div>
      {activeDetail ? (
        <div className={"mb-10"}>
          <div className="flex flex-col gap-3">
            <div className="flex justify-between mb-3">
              <p className="font-bold text-black text-2xl">Pack {packIndex}</p>
              <div>
                <img
                  src={deleteIcon}
                  className={"w-6   h-6"}
                  onClick={onDelete}
                  alt=""
                />
              </div>
            </div>
            <div className="flex flex-col mt-3">
              <div className="flex justify-between">
                <div>
                  <p className="text-2xl text-black font-bold ">{data?.detail?.product_name || data?.detail?.name || detail?.name}</p>
                  {(() => {
                    const vendorName = activeDetail?.businessName || activeDetail?.storeName || activeDetail?.restaurantName || activeDetail?.business?.name || data?.businessName || data?.detail?.businessName;
                    const isWholesale = data?.businessType === "wholesale" || data?.businessType === "raw_food" || data?.detail?.businessType === "wholesale" || data?.detail?.businessType === "raw_food";
                    if (vendorName && isWholesale) {
                      return (
                        <p className="text-xl font-bold text-gray-800 mt-1">
                          Sold by {vendorName}
                        </p>
                      );
                    }
                    return null;
                  })()}
                  {renderPackType()}
                  <p className="text-xl text-gray-800 ">
                    <span className='small_currency'>NGN</span>{' '}
                    <NumberFormat
                      thousandSeparator={true}
                      prefix={''}
                      className='numeric'
                      displayType={'text'}
                      value={roundDisplayPrice(data?.detail?.public_price || data?.detail?.priceWithMarkup || detail?.priceWithMarkup || detail?.public_price || 0)}
                    />{' '}</p>
                </div>

                <div className="flex flex-col items-center justify-between rounded-2xl border border-gray-300 bg-transparent py-4 px-3 h-28 w-12 select-none">
                  <button className="text-2xl text-gray-500 hover:text-black cursor-pointer leading-none" onClick={handleMinusQuantity}>
                    -
                  </button>
                  <span className="text-xl font-bold text-gray-900 leading-none">{quantity}</span>
                  <button className="text-2xl text-gray-500 hover:text-black cursor-pointer leading-none" onClick={handleAddQuantity}>
                    +
                  </button>
                </div>
              </div>
            </div>
          </div>
          {extrasState.filter(e => e.id !== "container_cost").length > 0 && (
            <div className="bg-[#E4E4E4] rounded-3xl my-5 p-3 border border-black ">
              <p className="text-black font-semibold">Your Selections</p>
              {extrasState.filter(e => e.id !== "container_cost").map((extra) => (
                <>
                  <div
                    className="flex justify-between items-center text-[#000] text-2xl mt-1"
                    key={extra.id}
                  >
                    <span>{extra.item.name}</span>
                    <div className="flex items-center gap-4">
                      <span className="ml-4 font-bold">
                        ₦{roundDisplayPrice(extra.price * extra.quantity)}
                      </span>
                    </div>

                    <button
                      className="text-lg text-red-500"
                      onClick={() => handleRemoveExtra(extra.id)}
                    >
                      🗑️
                    </button>
                  </div>
                  <div className="flex justify-end items-center gap-8">
                    <button
                      className="text-lg"
                      onClick={() => handleExtraQuantityChange(extra.id, -1)}
                    >
                      -
                    </button>
                    <span>{extra.quantity}</span>
                    <button
                      className="text-lg"
                      onClick={() => handleExtraQuantityChange(extra.id, 1)}
                    >
                      +
                    </button>
                  </div>
                </>
              ))}
            </div>
          )}
          {/*<div className="flex justify-between mt-4">*/}
          {/*    <p className="font-bold text-xl">Total Amount</p>*/}
          {/*    <p className="text-black font-bold">*/}
          {/*        <NumberFormat*/}
          {/*            value={totalAmount}*/}
          {/*            displayType={"text"}*/}
          {/*            thousandSeparator={true}*/}
          {/*            decimalScale={2}*/}
          {/*            fixedDecimalScale={true}*/}
          {/*            prefix={" ₦"}*/}
          {/*        />*/}
          {/*    </p>*/}
          {/*</div>*/}
        </div>
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
};

export default CartItem;
